module.exports = __webpack_public_path__ + "img/overview.da4d6eb7.svg";